import { lazy } from 'react'
import { Redirect } from 'react-router-dom'
import { RouteConfig } from 'react-router-config'
import AuthLayout from 'views/layouts/Auth'
import ErrorLayout from 'views/layouts/Error'
import SidebarLayout from 'views/layouts/Sidebar'
import InitialView from 'views/screens/general/Dashboard'

const routes: RouteConfig[] = [

	//Root
	{ path: '/', exact: true, component: () => <Redirect to='/dashboard' /> },

	//Auth
	{
		path: '/auth', component: AuthLayout as any, routes: [
			{ path: '/auth/login', exact: true, component: lazy(() => import('views/screens/auth/Login')) },
			{ path: '/auth/logout', exact: true, component: lazy(() => import('views/screens/auth/Logout')) },
			{ path: '/auth/reset-password', exact: true, component: lazy(() => import('views/screens/auth/ResetPassword')) },
			{ component: () => <Redirect to='/error/404' /> }
		]
	},

	//Errors
	{
		path: '/error', component: ErrorLayout as any, routes: [
			{ path: '/error/401', exact: true, component: lazy(() => import('views/screens/errors/Error401')) },
			{ path: '/error/403', exact: true, component: lazy(() => import('views/screens/errors/Error403')) },
			{ path: '/error/404', exact: true, component: lazy(() => import('views/screens/errors/Error404')) },
			{ path: '/error/500', exact: true, component: lazy(() => import('views/screens/errors/Error500')) },
			{ component: () => <Redirect to='/error/404' /> }
		]
	},

	//Main views
	{
		route: '*', component: SidebarLayout as any, routes: [
			{ path: '/dashboard', exact: true, component: InitialView, },

			{ path: '/website/pages/:tab?', exact: true, component: lazy(() => import('views/screens/website/Pages')) },
			{ path: '/website/pages/page/:id/:tab?', exact: true, component: lazy(() => import('views/screens/website/PageDetails')) },
			{ path: '/website/dictionary', exact: true, component: lazy(() => import('views/screens/website/Dictionary')) },
			{ path: '/website/dictionary/entry/:id', exact: true, component: lazy(() => import('views/screens/website/DictionaryDetails')) },
			{ path: '/website/media-library', exact: true, component: lazy(() => import('views/screens/website/MediaLibrary')) },
			{ path: '/website/media-library/file/:id', exact: true, component: lazy(() => import('views/screens/website/MediaLibraryDetails')) },
			{ path: '/website/blog/:tab?', exact: true, component: lazy(() => import('views/screens/blog/Articles')), },
			{ path: '/website/blog/article/:id/:tab?', exact: true, component: lazy(() => import('views/screens/blog/ArticleDetails')) },
			{ path: '/website/blog/category/:id/:tab?', exact: true, component: lazy(() => import('views/screens/blog/ArticlesCategoryDetails')) },

			{ path: '/shop/items/:tab?', exact: true, component: lazy(() => import('views/screens/shop/Products')), },
			{ path: '/shop/items/product/:id/:tab?', exact: true, component: lazy(() => import('views/screens/shop/ProductDetails')) },
			{ path: '/shop/items/category/:id/:tab?', exact: true, component: lazy(() => import('views/screens/shop/ProductsCategoryDetails')) },
			{ path: '/shop/wishlists', exact: true, component: lazy(() => import('views/screens/shop/Wishlists')), },
			{ path: '/shop/carts', exact: true, component: lazy(() => import('views/screens/shop/Carts')), },
			{ path: '/shop/carts/cart/:id/:tab?', exact: true, component: lazy(() => import('views/screens/shop/CartDetails')) },
			{ path: '/shop/orders', exact: true, component: lazy(() => import('views/screens/shop/Orders')), },
			{ path: '/shop/orders/order/:id/:tab?', exact: true, component: lazy(() => import('views/screens/shop/OrderDetails')) },
			{ path: '/shop/customers', exact: true, component: lazy(() => import('views/screens/shop/Customers')), },

			{ path: '/admin/users', exact: true, component: lazy(() => import('views/screens/admin/Users')) },
			{ path: '/admin/users/user/:id/:tab?', exact: true, component: lazy(() => import('views/screens/admin/UsersDetails')) },
			{ path: '/admin/automation', exact: true, component: lazy(() => import('views/screens/admin/Automation')), },
			{ path: '/admin/settings', exact: true, component: lazy(() => import('views/screens/admin/Settings')), },

			{ path: '/dev/overview/', exact: true, component: lazy(() => import('views/screens/dev/Overview')) },
			{ path: '/dev/pages/:id/manage', exact: true, component: lazy(() => import('views/screens/dev/DevPageSectionsManager')) },
			{ path: '/dev/media-library/folders', exact: true, component: lazy(() => import('views/screens/dev/DevFolders')) },
			{ path: '/dev/media-library/folders/:id', exact: true, component: lazy(() => import('views/screens/dev/DevFolderDetails')) },
			{ path: '/dev/types/page', exact: true, component: lazy(() => import('views/screens/dev/DevPageTypes')) },
			{ path: '/dev/types/page/:id', exact: true, component: lazy(() => import('views/screens/dev/DevPageTypesDetails')) },
			{ path: '/dev/types/field-group', exact: true, component: lazy(() => import('views/screens/dev/DevFieldGroupTypes')) },
			{ path: '/dev/types/field-group/:id', exact: true, component: lazy(() => import('views/screens/dev/DevFieldGroupTypesDetails')) },
			{ path: '/dev/types/field', exact: true, component: lazy(() => import('views/screens/dev/DevFieldTypes')) },
			{ path: '/dev/types/field/:id', exact: true, component: lazy(() => import('views/screens/dev/DevFieldTypesDetails')) },
			{ path: '/dev/tags', exact: true, component: lazy(() => import('views/screens/dev/DevTags')) },
			{ path: '/dev/tags/:id', exact: true, component: lazy(() => import('views/screens/dev/DevTagsDetails')) },
			{ path: '/dev/users/roles', exact: true, component: lazy(() => import('views/screens/dev/DevRoles')) },
			{ path: '/dev/users/roles/:id', exact: true, component: lazy(() => import('views/screens/dev/DevRolesDetails')) },
			{ path: '/dev/users/permissions', exact: true, component: lazy(() => import('views/screens/dev/DevPermissions')) },
			{ path: '/dev/users/permissions/:id', exact: true, component: lazy(() => import('views/screens/dev/DevPermissionsDetails')) },

			{ component: () => <Redirect to='/error/404' /> }
		]
	},
]

export default routes